import { Text } from '../../shared/Text/Text';

interface StatsProps {
  stats: {
    Booked: number;
    Completed: number;
    Skipped: number;
    Canceled: number;
  };
}

const Stats = ({ stats }: StatsProps) => {
  return (
    <div className="flex mb-4">
      <div className="flex items-center text-success-30">
        <Text.Normal weight="bold">Booked:</Text.Normal>
        <span className="mr-16 text-lg font-medium">{stats.Booked}</span>
      </div>
      <div className="flex items-center text-success-50">
        <Text.Normal weight="bold">Completed:</Text.Normal>
        <span className="mr-16 text-lg font-medium">{stats.Completed}</span>
      </div>
      <div className="flex items-center text-primary-20">
        <Text.Normal weight="bold">Skipped:</Text.Normal>
        <span className="mr-16 text-lg font-medium">{stats.Skipped}</span>
      </div>
      <div className="flex items-center text-danger-40">
        <Text.Normal weight="bold">Canceled:</Text.Normal>
        <span className="mr-16 text-lg font-medium">{stats.Canceled}</span>
      </div>
    </div>
  );
};

export default Stats;
